import { FC } from 'react';
import { ErrorFields } from '../errors/ErrorFields';
import { StyledAccordianSummary, StyledAccordion, StyledAccordionDetails } from './RegistrationUpdateForm';
import BasePersonSection from '../shared/BaseCustomRegistrationSection';
import RegistrationPreferencesFields from '../shared/RegistrationPreferencesFields';
import PostalAddressFields from '../shared/PostalAddressFields';

interface RegistrationSectionProps {
}

const RegistrationSection: FC<RegistrationSectionProps> = ({
}) => {
    return (
        <>
        <BasePersonSection
            title="My Information"
            StyledAccordion={StyledAccordion}
            StyledAccordianSummary={StyledAccordianSummary}
            StyledAccordionDetails={StyledAccordionDetails}
            additionalFields={
                <>
                    <PostalAddressFields showPostalHeading={true} />
                    <RegistrationPreferencesFields />
                </>
            }
        />
        <ErrorFields
            errorFields={[
                "title",
                "firstName",
                "lastName",
                "email",
                "mobile",
                "dietaryRequirements",
                "linkedInLink",
                "twitterLink",
                "jobDescription",
                "institution",
                "address",
                "suburb",
                "postcode",
                "country",
                "state"
            ]}
        />
        </>

    )
}

export default RegistrationSection;
